
define( 'FORCES_AND_MOTION_BASICS/../nls/pl/forces-and-motion-basics-strings',{
          "none": "brak",
          "force": "Siła",
          "values": "Wartości",
          "frictionTitle": "Tarcie",
          "redWins": "Czerwony wygrywa!",
          "frictionForce": "Siła tarcia",
          "pause": "Pauza",
          "friction": "Tarcie",
          "accelerationLab": "Przyspieszenia - Laboratorium",
          "forces-and-motion-basics.name": "Siły i ruch: Podstawy",
          "appliedForce": "Przyłożona siła",
          "leftForce": "Siła z lewej",
          "rightForce": "Siła z prawej",
          "acceleration": "Przyspieszenie",
          "sound": "Dźwięk",
          "lots": "duże",
          "forces": "Siły",
          "motion": "Ruch",
          "tugOfWar": "Przeciąganie liny",
          "go": "Start!",
          "newtons.n": "N",
          "sumOfForcesEqualsZero": "Siła wypadkowa = 0",
          "blueWins": "Niebieski wygrywa!",
          "speed": "Prędkość",
          "sumOfForces": "Siła wypadkowa",
          "return": "Wróć",
          "translation.credits": "Andrzej Batorski",
          "newtons": "N",
          "masses": "Masy"
        } );